/** Upper bound of a template variable catalogue sent with a compose request. */
export const COMPOSE_MESSAGE_MAX_PLACEHOLDERS = 120;
